/* eslint-disable max-lines-per-function */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCurrentUser } from 'src/models/lmsConfig/queries';
import axios from 'src/workspace/axios';
import {
  setLeaderboards,
  setPerformanceCards,
  setRankings,
  setStatus,
} from './slice';

const fetchLeaderboards = createAsyncThunk(
  'leaderboards',
  async (_, { dispatch }) => {
    try {
      const { data } = await axios.post('/performance/v1/leaderboard/list', {
        timestamp: new Date().getTime(),
        user_id: getCurrentUser()?.code,
        filters: '{}',
        source: 'web',
      });
      dispatch(setLeaderboards(data?.result?.leaderboard_configs || []));
    } catch (e) {
      dispatch(setStatus({ leaderboards_list: 'error' }));
    }
  },
);

// { userCode, leaderboardCode, payload, pagination }
export const fetchDashboardRankings = createAsyncThunk(
  'dashboardRankings',
  async ({ payload }: any, { dispatch }) => {
    try {
      const response = await axios.post(
        '/performance/v1/leaderboard/rankings',
        payload,
      );

      const { data } = response?.data?.result || {};
      const { ranking_list_view_type: rankingListViewType } =
        response?.data?.result || {};
      const rankings = data?.table?.data || [];
      const rankingsMeta = {
        lastUpdated: data?.meta?.last_updated,
        startDate: data?.meta?.leaderboard_start_date,
      };
      const individual = data?.individual || {};

      const columns = Object.keys(data?.table?.headings || {}).map((key) => ({
        field: key,
        title: data?.table?.headings[key],
        name: data?.table?.headings[key],
      }));

      dispatch(
        setRankings({
          data: rankings,
          table: {
            columns,
            title: data?.table?.title || '',
          },
          meta: rankingsMeta,
          individual,
          listViewOptions: rankingListViewType?.code_name_spinner_options || [
            { code: 'all', name: 'All' },
          ],
        }),
      );
    } catch (e) {
      dispatch(setStatus({ rankings: 'error' }));
    }
  },
);

export const fetchPerformanceCards = createAsyncThunk(
  'performanceCards',
  async (_, { dispatch }) => {
    try {
      const { data } = await axios.get('/performance/v1/cards');
      dispatch(
        setPerformanceCards(
          data?.results?.filter((card) => card.type === 'performance_card') ||
            [],
        ),
      );
    } catch (e) {
      dispatch(setStatus({ dashboard: 'error' }));
    }
  },
);

const onUpdate = async ({ dispatch }) => {
  dispatch(fetchPerformanceCards());
  dispatch(fetchLeaderboards());
};

const onActivate = () => {};

const onDeactivate = () => {};

export default { onActivate, onDeactivate, onUpdate };
